// StoreExpenseCarousel.jsx
import { Carousel, Image } from 'react-bootstrap';

const StoreExpenseCarousel = ({ images }) => {
  if (!images || images.length === 0) {
    return <p>No images available.</p>;
  }
  return (
    <Carousel>
      {images.map((image, index) => (
        <Carousel.Item key={index}>
          <Image
            className="d-block w-100"
            src={image}
            alt={`StoreExpense Image ${index + 1}`}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
};
export default StoreExpenseCarousel;